import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  Error,
  GetTestConfigTaskDetailsResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  onSuccess?: (response: GetTestConfigTaskDetailsResponse) => void
  onError?: (error: Error) => void
  children?: (data: GetTestConfigTaskDetailsResponse) => ReactElement
}

const GetAiTestConfigTaskDetailsRequest = ({
  id,
  onSuccess,
  onError,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/testconfigtasks/${id}/details`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetAiTestConfigTaskDetailsRequest
